<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <h1 class="text-uppercase font-weight-bold my-2">Listado de Lotes</h1>
      <server-filterable-table
        :downloadeable="false"
        :column_display="column_display"
        :columns="columns"
        :filterable="filterable"
        :headings="headings"
        :listColumns="listColumns"
        :url="url"
        @on-loading="loading = $event"
        :action-buttons="action_buttons"
        @on-arrow-right-action="(e) => openInventory(e.id)"
      />
    </div>
  </div>
</template>

<script>
import ServerFilterableTable from "@/bagno_views/ServerFilterableTable";
export default {
  name: "LotList",
  components: {
    ServerFilterableTable
  },
  data() {
    return {
      title: "Listado de Lotes",
      loading: false,
      action_buttons: ["arrow-right"],
      columns: [
        "number",
        "client_customer_name",
        "origin_name",
        "waybill_number",
        "waybill_date",
        "daystay",
        "variety_name",
        "condition",
        "product_type_name",
        "contents_in_process",
        "contents_consumed",
        "contents_count"
      ],
      filterable: ["number", "client_customer_name", "origin_name", "waybill_number", "condition", "product_type_name"],
      headings: {
        number: "Lote",
        client_customer_name: "Exportadora",
        origin_name: "Huerto",
        waybill_number: "# Guía",
        waybill_date: "Fecha Recepción",
        daystay: "Antiguedad",
        variety_name: "Variedad",
        condition: "Condición",
        product_name: "Especie",
        product_type_name: "Tipo Producto",
        contents_in_process: "En Proceso",
        contents_consumed: "Consumidos",
        contents_count: "Totales"
      },
      listColumns: {
        inventory_type: [
          { id: "Mensual", text: "Mensual" },
          { id: "Bi-Mensual", text: "Bi-Mensual" }
        ]
      }
    };
  },
  computed: {
    url() {
      return "/api/v1/lot_list/";
    }
  }
};
</script>

<style></style>
